"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '5 0 90 90';

var Code = function Code() {
  return _react["default"].createElement("g", null, _react["default"].createElement("polygon", {
    points: "35.39 62.26 18.56 45.44 35.39 28.61 30.44 23.66 8.66 45.44 30.44 67.21 35.39 62.26"
  }), _react["default"].createElement("polygon", {
    points: "66.23 28.61 83.05 45.44 66.23 62.26 71.18 67.21 92.95 45.44 71.18 23.66 66.23 28.61"
  }), _react["default"].createElement("rect", {
    x: "19.51",
    y: "41.94",
    width: "63.62",
    height: "7",
    transform: "translate(-5.47 83.82) rotate(-75.56)"
  }));
};

var svgProps = {
  viewBox: viewBox
};

var _default = (0, _createSvgIcon["default"])(Code, svgProps);

exports["default"] = _default;